'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _css = require('antd/lib/modal/style/css');

var _modal = require('antd/lib/modal');

var _modal2 = _interopRequireDefault(_modal);

var _css2 = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _css3 = require('antd/lib/select/style/css');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _product_form = require('../components/product_form');

var _product_form2 = _interopRequireDefault(_product_form);

var _template = require('../actions/template');

var _product = require('../actions/product');

var _reseller = require('../actions/reseller');

var _with_product_type = require('../hocs/with_product_type');

var _with_product_type2 = _interopRequireDefault(_with_product_type);

var _constants = require('../constants');

var _qrcode = require('qrcode');

var _qrcode2 = _interopRequireDefault(_qrcode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = _select2.default.Option;

var ProductEdit = _react2.default.createClass({
  displayName: 'ProductEdit',
  getInitialState: function getInitialState() {
    return {
      showModal: false,
      imageUrl: null
    };
  },
  handleSubmit: function handleSubmit(values) {
    this.props.dispatch((0, _product.postProductIfNeeded)(values, this.props.router));
  },
  componentDidMount: function componentDidMount() {
    this.props.dispatch((0, _template.fetchTemplatesIfNeeded)());
    this.props.dispatch((0, _reseller.fetchResellersData)());
  },
  onShowModal: function onShowModal(index, record) {
    var sku_id = record.sku_id;
    this.setState({
      sku_id: sku_id,
      showModal: true
    });
  },
  closeModal: function closeModal() {
    this.setState({
      showModal: false
    });
  },
  onCreateQRCode: function onCreateQRCode(value, product) {
    var that = this;
    if (!product.id) {
      _message2.default.error('没有找到该商品');
      return;
    }
    if (!this.state.sku_id) {
      _message2.default.error('没有找到该商品的规格');
      return;
    }
    if (!value || value === 'disabled') {
      _message2.default.error('请选择分销商');
      this.setState({
        imageUrl: null
      });
      return;
    }
    var url = _constants.API_H5_BASE_URL + '?product_id=' + product.id + '&product_sku_id=' + this.state.sku_id + '&reseller_id=' + value;
    _qrcode2.default.toDataURL(url, function (err, url) {
      if (err) {
        _message2.default.error(err);
      } else {
        that.setState({
          imageUrl: url
        });
      }
    });
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        products = _props.products,
        productTypes = _props.productTypes,
        templates = _props.templates,
        selectedMedia = _props.selectedMedia,
        params = _props.params,
        resellers = _props.resellers;

    var product = products.filter(function (o) {
      return o.id == params.productID;
    })[0];
    return _react2.default.createElement(
      'div',
      { id: 'product-edit' },
      _react2.default.createElement(_product_form2.default, { onSubmit: this.handleSubmit, selectedMedia: selectedMedia, product: product,
        types: productTypes, templates: templates, showModal: this.onShowModal, params: params }),
      _react2.default.createElement(
        _modal2.default,
        { visible: this.state.showModal, title: '\u751F\u6210\u4E8C\u7EF4\u7801', destroyOnClose: true, closable: false,
          onCancel: this.closeModal, onOk: this.closeModal },
        _react2.default.createElement(
          _select2.default,
          { style: { width: 200 }, onChange: function onChange(e) {
              return _this.onCreateQRCode(e, product);
            }, defaultValue: 'disabled' },
          _react2.default.createElement(
            Option,
            { value: 'disabled', disabled: true },
            '\u8BF7\u9009\u62E9\u5206\u9500\u5546'
          ),
          resellers && resellers.map(function (item, index) {
            return _react2.default.createElement(
              Option,
              { value: item.reseller_id },
              item.name
            );
          })
        ),
        _react2.default.createElement('img', { src: this.state.imageUrl,
          style: { width: '200px', height: '200px', display: 'block', border: '1px solid #eee' } })
      )
    );
  }
});

var mapStateToProps = function mapStateToProps(store) {
  var products = store.product.products;
  var media = store.media.media;
  var templates = store.template.templates;
  var productTypes = store.productType.productTypes;
  var resellers = store.reseller.resellers;

  return {
    selectedMedia: media.selectedMedia,
    products: products.items,
    templates: templates.items,
    productTypes: productTypes.items,
    resellers: resellers.items
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _with_product_type2.default)(ProductEdit));


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/product_edit.js
// module id = 1480
// module chunks = 0